export const threatIncidents = [
  {
    id: "ransomware-ot-network",
    code: "INC-2024-0001",
    title: "Ransomware Detected - OT Network",
    severity: "critical",
    description: "Suspicious encryption activity detected on PLC-PROD-12",
    affected: "PLC-PROD-12",
    assignee: "SOC Team Alpha",
    created: "2024-12-15 09:23",
    updated: "2024-12-15 09:45",
    status: "contained",
    detectionSource: 5,
    affectedAssetsCount: 3,
    mitreCount: 4,
    timelineEventsCount: 9,
    impact: {
      scope: "Limited to OT Production Zone",
      severity: "Critical - Active encryption detected",
      business: "Production Line 2 temporarily halted",
      data: "No data exfiltration detected",
    },
    assets: [
      {
        name: "PLC-PROD-12",
        type: "PLC",
        ip: "10.50.12.45",
        zone: "OT Production",
      },
      {
        name: "SCADA-CTRL-03",
        type: "SCADA",
        ip: "10.50.12.46",
        zone: "OT Production",
      },
      {
        name: "HMI-FLOOR-2",
        type: "HMI",
        ip: "10.50.13.12",
        zone: "OT Production",
      },
    ],
    iocs: [
      {
        label: "File Hash",
        value: "SHA256: a3f2b8c4d5e6f7...",
        severity: "critical",
      },
      {
        label: "IP Address",
        value: "203.45.167.89 (Russia)",
        severity: "high",
      },
      { label: "Domain", value: "malicious-c2.onion", severity: "critical" },
      { label: "Process", value: "encrypt.exe", severity: "critical" },
      { label: "Network Port", value: "TCP/4444", severity: "medium" },
    ],
    mitreTechniques: [
      {
        id: "T1486",
        name: "Data Encrypted for Impact",
        tactic: "Impact",
      },
      {
        id: "T1059",
        name: "Command and Scripting Interpreter",
        tactic: "Execution",
      },
      {
        id: "T1071",
        name: "Application Layer Protocol",
        tactic: "Command and Control",
      },
    ],
    responseActions: [
      {
        action: "Network Isolation",
        status: "completed",
        timestamp: "2024-12-15 09:23:47",
        result: "Success",
      },
      {
        action: "Malware Removal",
        status: "completed",
        timestamp: "2024-12-15 09:40:22",
        result: "Success",
      },
      {
        action: "System Restore",
        status: "in-progress",
        timestamp: "2024-12-15 09:47:00",
        result: "Pending",
      },
      {
        action: "Security Patch",
        status: "pending",
        timestamp: "-",
        result: "Scheduled",
      },
    ],
    collectedArtifacts: [
      {
        name: "forensic-memory-dump.bin",
        type: "Memory Dump",
        size: "4.2 GB",
      },
      {
        name: "network-capture.pcap",
        type: "Network Traffic",
        size: "847 MB",
      },
      {
        name: "malware-sample.exe",
        type: "Malware Sample",
        size: "2.4 MB",
      },
      {
        name: "system-logs.zip",
        type: "System Logs",
        size: "156 MB",
      },
    ],
    securityRecommendations: [
      "Apply latest security patches to all OT devices",
      "Implement stricter network segmentation between zones",
      "Enable additional behavioral monitoring on critical assets",
      "Conduct security awareness training for OT personnel",
    ],
    analystNotes: [
      {
        author: "SOC Team Alpha",
        timestamp: "2024-12-15 09:32",
        note: "Initial analysis suggests this is a targeted attack on OT infrastructure. Ransomware variant matches known LockBit 3.0 signatures.",
      },
      {
        author: "SOC Team Alpha",
        timestamp: "2024-12-15 09:38",
        note: "Good news - AI system caught this early. No encryption actually completed. Files are intact.",
      },
      {
        author: "Security Manager",
        timestamp: "2024-12-15 09:42",
        note: "Excellent work on containment. Please prepare detailed incident report for CISO by EOD.",
      },
    ],
    timeline: [
      "Threat detected by behavior analytics engine.",
      "OT segment isolated from corporate network.",
      "Snapshot preserved for forensic review.",
    ],
    incidentTimeline: [
      {
        title: "Initial Detection",
        description: "Anomalous encryption pattern detected on PLC-PROD-12",
        source: "AI System",
        timestamp: "2024-12-15 09:23:14",
        tone: "critical",
      },
      {
        title: "Auto-Containment Triggered",
        description: "Network isolation applied to affected zone",
        source: "QuantLayer AI",
        timestamp: "2024-12-15 09:23:47",
        tone: "info",
      },
      {
        title: "SOC Team Notified",
        description: "Priority alert sent to SOC Team Alpha",
        source: "System",
        timestamp: "2024-12-15 09:25:12",
        tone: "info",
      },
      {
        title: "Analyst Assignment",
        description: "Incident assigned to SOC Team Alpha",
        source: "SOC Manager",
        timestamp: "2024-12-15 09:28:35",
        tone: "info",
      },
      {
        title: "Investigation Started",
        description: "Forensic analysis initiated on affected assets",
        source: "SOC Team Alpha",
        timestamp: "2024-12-15 09:31:22",
        tone: "info",
      },
      {
        title: "Malware Identified",
        description: "Ransomware variant identified: LockBit 3.0",
        source: "SOC Team Alpha",
        timestamp: "2024-12-15 09:35:08",
        tone: "warning",
      },
      {
        title: "Additional Assets Scanned",
        description: "Full zone scan initiated for lateral movement",
        source: "SOC Team Alpha",
        timestamp: "2024-12-15 09:38:45",
        tone: "info",
      },
      {
        title: "C2 Communication Blocked",
        description: "Outbound connections to 203.45.167.89 blocked",
        source: "Firewall",
        timestamp: "2024-12-15 09:42:18",
        tone: "info",
      },
      {
        title: "Status Update: Contained",
        description: "Threat contained, no spread detected",
        source: "SOC Team Alpha",
        timestamp: "2024-12-15 09:45:00",
        tone: "success",
      },
    ],
    indicators: ["Encrypted file writes", "Lateral movement attempt"],
    remediation: ["Isolate PLC-PROD-12", "Reimage affected host"],
  },
  {
    id: "unauthorized-access-attempt",
    code: "INC-2024-0002",
    title: "Unauthorized Access Attempt",
    severity: "high",
    description: "Multiple failed authentication attempts from external IP",
    affected: "SCADA-CTRL-01",
    assignee: "John Smith",
    created: "2024-12-15 08:12",
    updated: "2024-12-15 10:30",
    status: "investigating",
    detectionSource: 5,
    affectedAssetsCount: 1,
    mitreCount: 2,
    timelineEventsCount: 5,
    impact: {
      scope: "Corporate Network",
      severity: "High - Brute force pattern detected",
      business: "No production impact",
      data: "No data exfiltration detected",
    },
    assets: [
      {
        name: "SCADA-CTRL-01",
        type: "SCADA",
        ip: "10.50.21.10",
        zone: "Corporate",
      },
    ],
    iocs: [
      { label: "IP Address", value: "198.51.100.24", severity: "high" },
      { label: "User Agent", value: "curl/7.81.0", severity: "medium" },
    ],
    mitreTechniques: [
      {
        id: "T1110",
        name: "Brute Force",
        tactic: "Credential Access",
      },
      {
        id: "T1078",
        name: "Valid Accounts",
        tactic: "Defense Evasion",
      },
    ],
    responseActions: [
      {
        action: "Block External IP",
        status: "completed",
        timestamp: "2024-12-15 08:25:10",
        result: "Success",
      },
      {
        action: "Credential Reset",
        status: "completed",
        timestamp: "2024-12-15 09:15:02",
        result: "Success",
      },
      {
        action: "MFA Enforcement",
        status: "in-progress",
        timestamp: "2024-12-15 10:12:44",
        result: "Pending",
      },
    ],
    collectedArtifacts: [
      {
        name: "auth-failures.csv",
        type: "Login Audit",
        size: "2.1 MB",
      },
      {
        name: "firewall-blocklist.txt",
        type: "Firewall Export",
        size: "640 KB",
      },
    ],
    securityRecommendations: [
      "Enable adaptive MFA for privileged accounts",
      "Lock accounts after repeated failed attempts",
      "Review external access policies for SCADA systems",
    ],
    analystNotes: [
      {
        author: "SOC Team",
        timestamp: "2024-12-15 08:30",
        note: "Multiple failed logins from external IP range. Monitoring for persistence.",
      },
    ],
    timeline: [
      "Detected repeated login failures.",
      "External IP added to watchlist.",
      "Credential reset initiated for impacted accounts.",
    ],
    indicators: ["Brute force pattern", "Geolocation mismatch"],
    remediation: ["Block external IP range", "Force MFA reset"],
  },
  {
    id: "command-injection-attack",
    code: "INC-2024-0003",
    title: "Command Injection Attack",
    severity: "critical",
    description: "Malicious commands detected in OPC-UA traffic",
    affected: "OT Gateway",
    assignee: "Sarah Johnson",
    created: "2024-12-14 22:15",
    updated: "2024-12-15 01:22",
    status: "mitigated",
    detectionSource: 5,
    affectedAssetsCount: 2,
    mitreCount: 3,
    timelineEventsCount: 7,
    impact: {
      scope: "OT Gateway Segment",
      severity: "Critical - Command injection blocked",
      business: "Minor operator delays",
      data: "No sensitive data movement detected",
    },
    assets: [
      {
        name: "OT Gateway",
        type: "Gateway",
        ip: "10.50.30.12",
        zone: "OT Production",
      },
      {
        name: "PLC-CTRL-07",
        type: "PLC",
        ip: "10.50.30.33",
        zone: "OT Production",
      },
    ],
    iocs: [
      { label: "Protocol", value: "OPC-UA", severity: "high" },
      { label: "Payload", value: "cmd=write_config", severity: "critical" },
    ],
    mitreTechniques: [
      {
        id: "T1059",
        name: "Command and Scripting Interpreter",
        tactic: "Execution",
      },
      {
        id: "T1203",
        name: "Exploitation for Client Execution",
        tactic: "Execution",
      },
      {
        id: "T1021",
        name: "Remote Services",
        tactic: "Lateral Movement",
      },
    ],
    responseActions: [
      {
        action: "Gateway Rule Update",
        status: "completed",
        timestamp: "2024-12-14 22:35:12",
        result: "Success",
      },
      {
        action: "Patch Deployment",
        status: "in-progress",
        timestamp: "2024-12-15 00:10:05",
        result: "Pending",
      },
    ],
    collectedArtifacts: [
      {
        name: "opcua-payloads.json",
        type: "Protocol Capture",
        size: "18 MB",
      },
      {
        name: "gateway-config.diff",
        type: "Config Diff",
        size: "84 KB",
      },
    ],
    securityRecommendations: [
      "Deploy updated gateway signatures across OT edge nodes",
      "Audit OPC-UA access rules and rate limits",
      "Schedule emergency patch window for critical gateways",
    ],
    analystNotes: [
      {
        author: "SOC Analyst",
        timestamp: "2024-12-14 23:10",
        note: "Payload matched known command injection pattern. Gateway rules updated.",
      },
    ],
    timeline: [
      "Suspicious OPC-UA calls flagged.",
      "Gateway rules updated to block payload signature.",
      "SOC validated containment actions.",
    ],
    indicators: ["OPC-UA command anomaly", "Unauthorized command payloads"],
    remediation: ["Apply gateway patch", "Rotate OT gateway keys"],
  },
  {
    id: "anomalous-network-traffic",
    code: "INC-2024-0004",
    title: "Anomalous Network Traffic",
    severity: "medium",
    description: "Unusual data exfiltration pattern detected",
    affected: "IOT-SENSOR-247",
    assignee: "AI System",
    created: "2024-12-14 18:45",
    updated: "2024-12-15 06:12",
    status: "monitoring",
    detectionSource: 5,
    affectedAssetsCount: 1,
    mitreCount: 1,
    timelineEventsCount: 4,
    impact: {
      scope: "IoT Sensor VLAN",
      severity: "Medium - Unusual outbound traffic",
      business: "No operational impact",
      data: "Outbound traffic throttled",
    },
    assets: [
      {
        name: "IOT-SENSOR-247",
        type: "Sensor",
        ip: "10.50.40.21",
        zone: "OT Production",
      },
    ],
    iocs: [{ label: "Destination", value: "203.0.113.10", severity: "medium" }],
    mitreTechniques: [
      {
        id: "T1041",
        name: "Exfiltration Over C2 Channel",
        tactic: "Exfiltration",
      },
    ],
    responseActions: [
      {
        action: "Traffic Throttling",
        status: "completed",
        timestamp: "2024-12-14 19:05:30",
        result: "Success",
      },
      {
        action: "Firmware Audit",
        status: "pending",
        timestamp: "-",
        result: "Scheduled",
      },
    ],
    collectedArtifacts: [
      {
        name: "sensor-netflow.csv",
        type: "Netflow Export",
        size: "5.6 MB",
      },
    ],
    securityRecommendations: [
      "Throttle outbound IoT traffic by policy",
      "Implement anomaly-based alerts for sensor VLAN",
      "Validate firmware integrity on field devices",
    ],
    analystNotes: [
      {
        author: "AI System",
        timestamp: "2024-12-14 19:12",
        note: "Outbound traffic spike correlated with firmware update window.",
      },
    ],
    timeline: [
      "Anomaly score exceeded threshold.",
      "Sensor moved to monitored VLAN.",
      "Awaiting analyst review.",
    ],
    indicators: ["Unusual outbound volume", "Destination mismatch"],
    remediation: ["Throttle outbound traffic", "Audit sensor firmware"],
  },
  {
    id: "privilege-escalation-attempt",
    code: "INC-2024-0005",
    title: "Privilege Escalation Attempt",
    severity: "high",
    description: "User attempting to gain admin privileges",
    affected: "Corporate Network",
    assignee: "Mike Chen",
    created: "2024-12-14 14:20",
    updated: "2024-12-14 09:15",
    status: "resolved",
    detectionSource: 5,
    affectedAssetsCount: 3,
    mitreCount: 3,
    timelineEventsCount: 9,
    impact: {
      scope: "Limited to Corporate Directory",
      severity: "High - Privilege escalation blocked",
      business: "No business disruption detected",
      data: "No data exfiltration detected",
    },
    assets: [
      {
        name: "Corporate Network",
        type: "Directory",
        ip: "10.50.50.20",
        zone: "Corporate",
      },
      {
        name: "SCADA-CTRL-03",
        type: "SCADA",
        ip: "10.50.12.46",
        zone: "OT Production",
      },
      {
        name: "HMI-FLOOR-2",
        type: "HMI",
        ip: "10.50.13.12",
        zone: "OT Production",
      },
    ],
    iocs: [
      {
        label: "File Hash",
        value: "SHA256: a3f2b8c4d5e6f7...",
        severity: "critical",
      },
      {
        label: "IP Address",
        value: "203.45.167.89 (Russia)",
        severity: "high",
      },
      { label: "Domain", value: "malicious-c2.onion", severity: "critical" },
      { label: "Process", value: "encrypt.exe", severity: "critical" },
      { label: "Network Port", value: "TCP/4444", severity: "medium" },
    ],
    mitreTechniques: [
      {
        id: "T1068",
        name: "Exploitation for Privilege Escalation",
        tactic: "Privilege Escalation",
      },
      {
        id: "T1078",
        name: "Valid Accounts",
        tactic: "Defense Evasion",
      },
      {
        id: "T1098",
        name: "Account Manipulation",
        tactic: "Persistence",
      },
    ],
    responseActions: [
      {
        action: "Session Termination",
        status: "completed",
        timestamp: "2024-12-14 14:32:10",
        result: "Success",
      },
      {
        action: "Access Review",
        status: "completed",
        timestamp: "2024-12-14 15:05:55",
        result: "Success",
      },
      {
        action: "Policy Update",
        status: "pending",
        timestamp: "-",
        result: "Scheduled",
      },
    ],
    collectedArtifacts: [
      {
        name: "access-review.xlsx",
        type: "Access Review",
        size: "420 KB",
      },
      {
        name: "audit-trail.log",
        type: "Audit Log",
        size: "3.2 MB",
      },
    ],
    securityRecommendations: [
      "Review privileged role assignments weekly",
      "Harden admin approval workflows",
      "Enforce just-in-time access for critical systems",
    ],
    analystNotes: [
      {
        author: "SOC Team",
        timestamp: "2024-12-14 14:40",
        note: "Privilege escalation attempt blocked. Account under review.",
      },
    ],
    timeline: [
      "Privilege escalation attempt detected.",
      "User session terminated.",
      "Account moved to remediation workflow.",
    ],
    indicators: ["Role change attempt", "Unauthorized admin access"],
    remediation: ["Reset user credentials", "Review access policies"],
  },
];
